import { TextField } from "@mui/material";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export default function PasswordForm() {
  const {
    formState: { errors },
    register,
  } = useFormContext();
  const { t } = useTranslation();
  return (
    <>
      <TextField
        fullWidth
        required
        size="medium"
        inputProps={{
          maxLength: 64,
          "data-testid": "auth.signup.password-input",
        }}
        label={t("Password")}
        type="password"
        error={!!errors.password}
        helperText={errors.password?.message}
        {...register("password")}
      />

      <TextField
        fullWidth
        required
        size="medium"
        inputProps={{
          maxLength: 64,
          "data-testid": "auth.signup.confirm-password-input",
        }}
        label={t("ConfirmPassword")}
        type="password"
        error={!!errors.confirmPassword}
        helperText={errors.confirmPassword?.message}
        {...register("confirmPassword")}
      />
    </>
  );
}
